import { useEffect } from 'react';

// react-router-dom components
import { useLocation } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

//  React components
import MDBox from 'components/MDBox';

//  React context
import { setLayout, useMaterialUIController } from 'context';

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'dashboard');
  }, [pathname]);

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        px: { xs: 1, sm: 3 },
        // pb: 3,
        position: 'relative',
        marginTop: 1.5,
        // [breakpoints.up("xl")]: {
        //   marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
        //   transition: transitions.create(["margin-left", "margin-right"], {
        //     easing: transitions.easing.easeInOut,
        //     duration: transitions.duration.standard,
        //   }),
        // },
      })}>
      {children}
    </MDBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
